import { Component, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { ApiServiceService } from "src/app/api-service.service";
import { Table } from "primeng/table";
import { formatDate } from "@angular/common";
import { SupplierUploadDocComponent } from "../../supplier-upload-doc/supplier-upload-doc.component";

import { AppUtility } from 'src/app/interceptor/appUtitlity';
import { Router } from "@angular/router";
import * as moment from "moment";
@Component({
  selector: 'app-asn-generation-form',
  templateUrl: './asn-generation-form.component.html',
  styleUrls: ['./asn-generation-form.component.scss']
})
export class AsnGenerationFormComponent {
  breadcrumb = [
    {
      title: "ASN-Generation",
      subTitle: "Dashboard",
    },
  ];
  selectedData: any[] = [];
  ASNform: FormGroup;
  route: any;
  i: any;
  documentList: any;
  today: Date = new Date();
  userroleName: any;
  supplierid: any
  loginid: any
  valueStreamdropdown: any[] = [];
  constructor(
    private fb: FormBuilder,
    private _apiService: ApiServiceService,
    private _utility: AppUtility,
    private router: Router

  ) {

  }

  @ViewChild('dt2') dataTable: Table;

  ngOnInit() {
    const data = history.state.data;

    this.loadSelectedData();
    this.getStatic();
    this.getvaluestream();
    this.userroleName = this._utility.getLocalStorageDetails();
    console.log(this.userroleName.supplierId, "user role");
    this.supplierid = this.userroleName.supplierId;
    this.loginid = this.userroleName.loginId;
    console.log(this.loginid);

  }
  async getStatic() {
    await this._apiService.getDocument().then((res: any) => {
      if (res.success) {
        this.documentList = res.returnValue.filter(res => res.documentType == 'Supplier');
      } else {
        this.documentList = [];
      }
    })
  }

  async getvaluestream() {
    await this._apiService.getvaluestream()
      .then((res: any) => {
        if (res.success == true) {
          this.valueStreamdropdown = res.returnValue;
        } else {
          this.valueStreamdropdown = [];
        }
      })
      .catch((error: any) => {
        this.valueStreamdropdown = [];
      });
  }
  keyPress(event: KeyboardEvent) {
    const pattern = /^\d+(\.\d{0,2})?$/;

    const inputValue = (event.target as HTMLInputElement).value;
    const proposedValue = inputValue + String.fromCharCode(event.charCode);

    if (!pattern.test(proposedValue)) {
      // Invalid input, prevent input
      event.preventDefault();
    }
  }
  loadSelectedData() {
    this.selectedData = this._apiService.getSelectedData(); // Fetch data from service
    console.log(this.selectedData);

    const hasInvoice = !!this.selectedData[0]?.invoicePath;
    const hasDelivery = !!this.selectedData[0]?.deliveryChaalanPath;

    this.ASNform = this.fb.group({
      items: this.fb.array(this.selectedData.map(item => this.createItemFormGroup(item))),
      invoice_doc: new FormControl(null, hasInvoice ? [] : Validators.required),
      delivery_doc: new FormControl(null, hasDelivery ? [] : Validators.required),
      eway_doc: new FormControl(''),
      docs: this.fb.array([]),
      invoice_num: new FormControl(null, [Validators.required]),
      InvoiceDate: new FormControl(null, [Validators.required])


    });
    console.log(this.ASNform.controls, "values");

    this.listenForShipChanges();
  }
  getdocs(): FormArray {
    return this.ASNform.get('docs') as FormArray;
  }
  addDocRow(string: any, index: any) {
    let ClothesArray = this.getdocs();
    if (string == 'add') {
      let newclothesArray = new FormGroup({
        fileName: new FormControl(''),
        file: new FormControl(''),
      });
      ClothesArray.insert(index + 1, newclothesArray);
    } else {
      ClothesArray.removeAt(index);
    }
  }


  createItemFormGroup(item: any): FormGroup {
    return this.fb.group({
      id: [item.orderNumber],
      poid: [item.id],
      itemNumber: [item.itemNumber.trim(), Validators.required],
      itemDesc: [item.itemDesc, Validators.required],
      orderDate: new FormControl(this.getnewDate(item.orderDate), [Validators.required]),
      requestedDate: new FormControl(this.getnewDate(item.requestedDate), [Validators.required]),
      schPickDate: new FormControl(this.getnewDate(item.promisedDeliveryDate)),
      quantityOpen: [item.quantityOpen, Validators.required],
      valueStream2: [item.valueStream2],
      unitPrice: [item.unitPrice, Validators.required],
      ship: [item.ship !== null ? item.ship : 0, [Validators.required]],
      shipAmount: [{ value: '', disabled: true }],
      linenumber: [item.lineNumber],
      ordertype: [item.orderType],
      addressnumber: [item.addressNumber],
      asnRemainingQuantity: [item.asnRemainingQuantity],
      businessUnit: [item.businessUnit],
      supplierid: [item.supplierId],
      asnId: [item.asnId || 0],
    },
      { validators: this.shipLessThanOpenQtyValidator() });
  }
  shipLessThanOpenQtyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const quantityOpen = control.get('quantityOpen')?.value;
      const ship = control.get('ship')?.value;
      const asnRemainingQuantity = control.get('asnRemainingQuantity')?.value;
      const errors: ValidationErrors = {};

      if (ship > quantityOpen) {
        errors['shipExceedsOpen'] = true;
      }
      if (ship > asnRemainingQuantity) {
        errors['shipExceedsOpen'] = true;
      }

      return Object.keys(errors).length > 0 ? errors : null;
    };
  }


  getFormattedDate(date: string): string {
    if (date) {
      const formattedDate = formatDate(date, 'yyyy/MM/dd', 'en-US'); // Format the date properly
      return formattedDate.trim(); // Ensure the date is trimmed
    }
    return '';
  }

  getnewDate(date: string): string {
    if (date) {
      const formattedDate = formatDate(date, 'dd/MM/yyyy', 'en-US'); // Format the date properly
      return formattedDate.trim(); // Ensure the date is trimmed
    }
    return '';
  }
  get items(): FormArray {
    return this.ASNform.get('items') as FormArray;
  }

  listenForShipChanges(): void {
    const itemsArray = this.ASNform?.get('items') as FormArray;

    itemsArray?.controls?.forEach((control, index) => {
      control.get('ship')?.valueChanges.subscribe((shipValue: number) => {
        const unitPrice = control.get('unitPrice')?.value;
        const shipAmount = shipValue && unitPrice ? shipValue * unitPrice : 0;
        control.get('shipAmount')?.setValue(shipAmount, { emitEvent: false });
      });
    });
  }

  ewayErrorMsg: string = '';

  onSubmit() {
    const suppliers = this.ASNform.value.items.flatMap(item => item.supplier2);
    console.log(suppliers, "all supplier");
    if (!this.ASNform.valid) {
      this._apiService.showMessage("Please fill form details", "error");
      return;
    }

    this._utility.loader(true);
    this.ewayErrorMsg = ''; // Reset Eway error before submit

    const invoiceNumber = this.ASNform.controls['invoice_num'].value;
    const invoicedate = this.getFormattedDate(this.ASNform.controls['InvoiceDate'].value);
    console.log("date", invoicedate);

    const items = this.ASNform.value.items.map(item => ({
      orderNumber: item.id,
      itemdesc: item.itemDesc,
      ordertype: item.ordertype,
      itemnumber: item.itemNumber,
      linenumber: item.linenumber,
      Poid: item.poid,
      ship: Number(item.ship),  // Ensure ship is a number
      QuantityOpen: item.quantityOpen,
      Value: Number(item.unitPrice) * Number(item.ship), // Ensure value is numeric
      addressNumber: item.addressnumber,
      valueStream2: item.valueStream2,
      InvoiceNumber: invoiceNumber,
      InvoiceDate: invoicedate,
      businessUnit: item.businessUnit,
      SupplierId: item.supplierid,
      AsnId: item.asnId || 0,
    }));
    console.log(items);


    // Create the payload
    const payload = new FormData();

    // Attach all uploaded docs
    this.ASNform.value.docs.forEach((doc: any) => {
      payload.append(doc.fileName, doc.file);
    });

    // Append other form fields
    payload.append('ItemsJson', JSON.stringify(items));
    payload.append('Invoice', this.ASNform.controls['invoice_doc'].value);
    payload.append('DeliveryChaalan', this.ASNform.controls['delivery_doc'].value);
    payload.append('EwayBill', this.ASNform.controls['eway_doc'].value);
    payload.append('InvoiceNumber', invoiceNumber);
    payload.append('LoginId', this.loginid);
    payload.append('TotalAmount', this.calculateTotalAmountWithTax().toString());
    payload.append('TaxAmount', this.calculateTotalTaxAmount().toString());
    // payload.append('InvoiceDate', this.getFormattedDate(this.ASNform.controls['InvoiceDate'].value));

    // API call
    this._apiService.asegeneration(payload)
      .then(response => {
        this._utility.loader(false);
        this._apiService.showMessage(response.message, 'success');

        setTimeout(() => {
          this.router.navigateByUrl("/generated-asn");
        }, 1000);
      })
      .catch(error => {
        console.error('API error:', error);
        this._utility.loader(false);

        const fullErrorMessage = error?.error?.error || error?.message || 'Unknown error';

        // Handle E-Way Bill validation errors from backend
        if (fullErrorMessage.includes("E-Way Bill is mandatory")) {
          this.ewayErrorMsg = fullErrorMessage;
        }

        // Show toast notification
        if (error.status === 400) {
          this._apiService.showMessage(error.error?.message || fullErrorMessage, 'error');
        } else {
          this._apiService.showMessage('An unexpected error occurred.', fullErrorMessage);
        }
      });
  }

  uploadDoc(event: Event, fileType: string, index?: number) {
    const file = this._utility.onFileChange(event);
    if (!file) {
      console.error('Invalid file selected:', file);
      return;
    }

    switch (fileType) {
      case 'invoice':
        this.ASNform.controls['invoice_doc'].setValue(file); // Set invoice file
        break;

      case 'delivery':
        this.ASNform.controls['delivery_doc'].setValue(file); // Set delivery file
        break;

      case 'eway':
        this.ASNform.controls['eway_doc'].setValue(file); // Set eway file
        break;
      case 'add_doc':
        if (index !== undefined) {
          const docsArray = this.ASNform.get('docs') as FormArray; // Access the FormArray
          console.log(docsArray);

          const docGroup = docsArray.at(index) as FormGroup; // Get the FormGroup at the specified index
          console.log(docsArray);
          if (docGroup) {
            docGroup.controls['file'].setValue(file); // Set the other_doc field in FormGroup
          }
          console.log(docGroup.controls['file'].value);

        }
        break;
      default:
        console.warn('Unsupported file type:', fileType);
    }

    console.log(`${fileType} document uploaded successfully`, file);
  }

  calculateTotalShipAmount(): number {
    return this.items.controls.reduce((acc, control) => {
      return acc + (control.get('shipAmount')?.value || 0);
    }, 0);
  }

  calculateTotalTaxAmount(): number {
    if (!this.valueStreamdropdown || this.valueStreamdropdown.length === 0) return 0;

    return this.items.controls.reduce((acc, control) => {
      const shipAmount = control.get('shipAmount')?.value || 0;
      const vsName = control.get('valueStream2')?.value;
      const vs = this.valueStreamdropdown.find(v => v.valueStreamName === vsName);

      let taxRate = 0;
      if (vs) {
        taxRate = (vs.cgst || 0) + (vs.igst || 0) + (vs.sgst || 0);
      }

      const taxAmount = (shipAmount * taxRate) / 100;
      return acc + taxAmount;
    }, 0);
  }

  calculateTotalAmountWithTax(): number {
    return this.calculateTotalShipAmount() + this.calculateTotalTaxAmount();
  }

}
